import { JDSBadgeV2NotificationProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSBadgeV2NotificationProps>
  ): React.FC<JDSBadgeV2NotificationProps> =>
  (props: JDSBadgeV2NotificationProps) => {
    return <Component {...props} />;
  };
